import React, { useState, useEffect } from 'react';
import logo from '../../assets/images/logo.png';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();
  
  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close menu and scroll to top when location changes (page navigation)
  useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      {/* Regular navbar for all screen sizes */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
            <img
              src={logo}
              alt="MuslimsRestro Logo"
              className="brand-logo"
            />
            <span>halal-bees</span>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/restaurants">Restaurants</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/hotels">Hotels</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">About</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact</Link>
              </li>
            </ul>
           
            <div className="d-flex">
              <Link to="/login" className="btn btn-outline-primary me-2">Login</Link>
              <Link to="/register" className="btn btn-primary">Sign Up</Link>
            </div>
          </div>
        </div>
      </nav>
      {/* Mobile bottom navigation */}
      {isMobile && (
        <div className="mobile-bottom-nav fixed-bottom shadow-lg d-md-none" style={{ backgroundColor: "#00704a" }}>
          <div className="d-flex justify-content-around py-2">
            <Link to="/" className="text-center text-decoration-none">
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-house-door-fill fs-4 text-white"></i>
                <span className="small text-white">Home</span>
              </div>
            </Link>
            <Link to="/restaurants" className="text-center text-decoration-none">
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-shop fs-4 text-white"></i>
                <span className="small text-white">Restaurants</span>
              </div>
            </Link>
            <Link to="/hotels" className="text-center text-decoration-none">
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-building fs-4 text-white"></i>
                <span className="small text-white">Hotels</span>
              </div>
            </Link>
            <Link to="/login" className="text-center text-decoration-none">
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-person-circle fs-4 text-white"></i>
                <span className="small text-white">Account</span>
              </div>
            </Link>
          </div>
        </div>
      )}
      {/* Add padding to the bottom of the page when mobile navigation is visible */}
      {isMobile && <div className="pb-5 mb-4"></div>}
    </>
  );
};

export default Header;